export default "__VITE_ASSET__NfvGz_DT__"